import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "../assets/css/common-ui.css";
import "../assets/css/mobile.css";
import App from "../App.vue";
import router from "./router";
import store from "../store";
import { postRequest, postKeyValueRequest, putRequest, deleteRequest, getRequest } from "../utils/api";
import { hasPermission } from "../utils/permission";

Vue.use(ElementUI);
Vue.config.productionTip = false;
document.title = "法多邦电销CRM";
Object.assign(Vue.prototype, { postRequest, postKeyValueRequest, putRequest, deleteRequest, getRequest, $hasPerm: hasPermission });
new Vue({ router, store, render: (h) => h(App) }).$mount("#app");
